import './blog.css';
import BannerCarousel from '../../components/bannerCarousel/BannerCarousel';
import { BannerImageData } from '../../dummyData/bannerCarouselData.js';
import BlogCard from '../../components/blogCard/BlogCard';
import EmptyPage from '../../components/empty-page/emptyPage';
import fetchBlogsData, { blogCount } from './fetchBlogsFun/fetchBlogsData';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import Pagination from '../../components/pagination/Pagination.jsx';

export default function Blog() {
    const [blogData, setBlogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [offSet, setOffSet] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const limit = 10;

    useEffect(() => {
        fetchBlogsData(setBlogData, setLoading, limit, offSet);
    }, [limit, offSet]);

    useEffect(() => {
        blogCount(setTotalCount, setLoading);
    }, []);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalCount / limit) > 1) {
            setPageNumber(+number);
            setOffSet(+offSetNumber);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div>
            <BannerCarousel className='blogCarousel' imageData={BannerImageData?.data} />
            <div className='customContainer blogBody'>
                <div className='blogsGrid'>
                    {blogData?.length === 0 ? (
                        <EmptyPage />
                    ) : (
                        blogData?.map((blog, blogIndex) => {
                            return <BlogCard blogData={blog} key={blogIndex} />;
                        })
                    )}
                </div>
                {/* <BlogRelated /> */}
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}
            </div>
            <div className='blogPagination'>
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalCount}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
            </div>
        </div>
    );
}
